import { ref, computed } from 'vue'
import { getToken, setToken, setUserInfo, clearAuth } from '@/utils/auth'
import { getInfo, logout } from '@/api/login'
import { ElMessage } from 'element-plus'

// 全局用户状态
const user = ref(null)
const token = ref(getToken())

// 初始化用户信息
export function initUserInfo() {
  if (token.value) {
    getUserInfoFromApi()
  }
}

// 从API获取用户信息
export async function getUserInfoFromApi() {
  try {
    const res = await getInfo()
    if (res.code === 200) {
      // 处理不同的API响应数据结构
      const userData = res.user || res.data || res
      user.value = userData
      setUserInfo(userData)
    } else {
      // 如果获取用户信息失败，可能是token过期
      clearAuth()
      user.value = null
      token.value = null
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    clearAuth()
    user.value = null
    token.value = null
  }
}

// 登录
export async function loginUser(loginData) {
  try {
    const res = await loginData
    if (res.code === 200) {
      token.value = res.token
      setToken(res.token)
      
      // 获取用户信息
      await getUserInfoFromApi()
      
      ElMessage.success('登录成功')
      return true
    } else {
      ElMessage.error(res.msg || '登录失败')
      return false
    }
  } catch (error) {
    console.error('登录失败:', error)
    ElMessage.error('登录失败，请稍后重试')
    return false
  }
}

// 退出登录
export async function logoutUser() {
  try {
    await logout()
    ElMessage.success('退出成功')
  } catch (error) {
    console.error('退出失败:', error)
  } finally {
    clearAuth()
    user.value = null
    token.value = null
  }
}

// 检查是否已登录
export const isLoggedIn = computed(() => !!token.value)

// 获取用户名
export const username = computed(() => {
  if (!user.value) return '用户'
  return user.value.username || user.value.nickName || user.value.name || user.value.phone || '用户'
})

// 获取用户头像
export const userAvatar = computed(() => user.value?.avatar || '')

// 获取用户信息
export const userInfo = computed(() => user.value)

export function useAuth() {
  return {
    user,
    token,
    isLoggedIn,
    username,
    userAvatar,
    userInfo,
    loginUser,
    logoutUser,
    getUserInfoFromApi,
    initUserInfo
  }
}
